import request from "@/utils/request";

export function checkLogin() {
  return request({ url: "/oauth/checkLogin", method: "post" });
}

export function login(data) {
  return request({ url: "/oauth/login", method: "post", data: data });
}

export function loginGuest() {
  return request({ url: "/oauth/loginGuest", method: "post" });
}

export function register(data) {
  return request({ url: "/oauth/register", method: "post", data: data });
}

export function forgetPwd(data) {
  return request({ url: `/forgetPwd`, method: "post", data: data });
}

export function forgetTkPwd(data) {
  return request({ url: `/user/forgetTkPwd`, method: "post", data: data });
}

export function logout() {
  return request({ url: "/oauth/logout", method: "post" });
}

export function getBalance() {
  return request({ url: "/user/balance", method: "post" });
}

// export function getValidBalance() {
//   return request({ url: '/user/validBalance', method: 'get' })
// }

export function getInfo() {
  return request({ url: "/user/info", method: "post" });
}

export function getUserMoney() {
  return request({ url: "/user/money/info", method: "post" });
}

export function getUserLevel() {
  return request({ url: "/user/level/info", method: "post" });
}

export function getUserPlanGroupInfo() {
  return request({ url: "/user/planGroup/info", method: "post" });
}

export function authInfo(data) {
  return request({ url: "/user/auth", method: "post", data: data });
}

export function updateInfo(data) {
  return request({ url: "/user/info/update", method: "post", data: data });
}

export function updatePassword(data) {
  return request({ url: "/user/updatePassword", method: "post", data: data });
}

export function updateTkPassword(data) {
  return request({ url: "/user/updateTkPassword", method: "post", data: data });
}

export function getBillList(data) {
  return request({ url: "/user/bill/list", method: "post", data: data });
}

export function getPackList(data) {
  return request({ url: "/user/pack/list", method: "post", data: data });
}

export function getWithdrawList(data) {
  return request({ url: "/user/withdraw/list", method: "post", data: data });
}

export function getLevelList() {
  return request({ url: "/userLevel/list", method: "get" });
}

export function getLevelInfo(levelId) {
  return request({ url: `/userLevel/${levelId}/info`, method: "get" });
}

export function rechargeLevel(levelId) {
  return request({ url: `/user/level/${levelId}/recharge`, method: "post" });
}

export function getCustomerList(params) {
  return request({ url: `/customer/list`, method: "get", params });
}

export function getNoticeList(type) {
  return request({ url: `/user/message/list/${type}`, method: "get" });
}

export function getTeamData(data) {
  return request({ url: `/user/team/data`, method: "post", data: data });
}

export function transfer2Balance(data) {
  return request({ url: `/user/convertCommission`, method: "post", data: data });
}

export function getChatUnread(data) {
  return request({ url: `/user/chat/getUnreadNum`, method: "get", data: data });
}
